<script lang="ts">
	import { FiltersTypeEnum } from '@app/models/api/enums/FiltersTypeEnum';
	import InputDate from '../../lib/elements/inputs/variants/InputDate.svelte';
	import Chip from '../../lib/elements/Chip.svelte';
	import InputSelect from '../../lib/elements/inputs/variants/InputSelect.svelte';
	import { goto } from '$app/navigation';
	import { t } from 'svelte-i18n';
	import { getContext } from 'svelte';
	import { smoothScrollToTop } from '$lib/utils/window';
	import Toggler from '$lib/elements/Toggler.svelte';

	export let filtersGroup;
	export let filter;

	let projectsContext = getContext('projects');

	let currentURL: URL;
	let currentURLSearchParams: URLSearchParams;

	const updateUrl = async (fg, f, isCumulative) => {
		smoothScrollToTop();
		currentURL = new URL(window.location.toString());
		currentURLSearchParams = currentURL.searchParams;
		currentURLSearchParams.delete('search');
		fg = $t(`filters.${fg}`);
		if (projectsContext) {
			projectsContext.resetTextSearchValue();
		}

		if (currentURLSearchParams.has(fg)) {
			if (isCumulative) {
				let currentFiltersGroupValues: string = currentURLSearchParams.get(fg);
				let currentFiltersGroupValuesArray: string[] = currentFiltersGroupValues.split(',');

				if (currentFiltersGroupValuesArray.includes(f)) {
					currentFiltersGroupValuesArray = currentFiltersGroupValuesArray.filter((v) => v !== f);
				} else {
					currentFiltersGroupValuesArray.push(f);
				}
				if (currentFiltersGroupValuesArray.length) {
					currentURLSearchParams.set(fg, currentFiltersGroupValuesArray.join());
				} else {
					currentURLSearchParams.delete(fg);
				}
			} else {
				currentURLSearchParams.set(fg, f);
			}
		} else {
			currentURLSearchParams.append(fg, f);
		}
		if (currentURLSearchParams.has('page')) {
			currentURLSearchParams.delete('page');
		}
		currentURL.search = currentURL.search.replaceAll('%2C', ',');
		await goto(currentURL);
	};
</script>

{#if filtersGroup.type === FiltersTypeEnum.DATE}
	<InputDate
		props={filter}
		on:input={() => {
			updateUrl(filtersGroup.value, filter.value);
		}}
	/>
{:else if filtersGroup.type === FiltersTypeEnum.CHIP}
	<Chip
		props={filter}
		on:click={(e) => {
			if (
				e.target.classList.contains('checkbox-label') ||
				e.target.classList.contains('checkbox-text')
			)
				return;
			updateUrl(filtersGroup.value, filter.value, true);
		}}
	/>
{:else if filtersGroup.type === FiltersTypeEnum.SELECT}
	<InputSelect
		props={filter}
		on:click={() => {
			updateUrl(filtersGroup.value, filter.value);
		}}
	/>
{:else if filtersGroup.type === FiltersTypeEnum.TOGGLER}
	<Toggler
		props={filter}
		on:change={() => {
			updateUrl(filtersGroup.value, filter.checked);
		}}
	/>
{/if}
